<script lang="ts" setup>
  import { computed } from "vue";

  interface Options {
    options: {
      href: string;
      label: string;
      iconName: string | null;
    };
  }

  const props = withDefaults(defineProps<Options>(), {});

  const iconClasses = computed(() => {
    return props.options.iconName ? { [props.options.iconName]: true } : {};
  });
</script>

<template>
  <a v-bind:href="options.href" class="link-entry">
    <i class="link-entry__icon fe" v-bind:class="iconClasses"></i>
    <div>{{ options.label }}</div>
  </a>
</template>

<style lang="scss" scoped>
  @use "shared/styles/colors";
  @use "shared/utils/context-menu/context-menu";

  .link-entry__icon {
    font-size: 16px;
    width: 22px;
    margin-left: 7px;

    color: colors.$color_context-menu--simple-entry--icon-color;
  }

  .link-entry {
    @include context-menu.entry;
    padding-left: 0; // adjust padding for icon

    display: flex;
    align-items: center;

    &:hover {
      &,
      .link-entry__icon {
        @include context-menu.entry--hover;
      }
    }
  }
</style>
